import { render, staticRenderFns } from "./Historia.vue?vue&type=template&id=fb36a096&"
import script from "./Historia.vue?vue&type=script&lang=js&"
export * from "./Historia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports